<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách Merchant từ Landing</h1>
    </div>
    <div class="card p-10 pt-15">
      <div class="card-header m-b-10">
        <div class="box-search">
          <div class="form-group">
            <input
              type="text"
              v-model="search.textSearch"
              class="form-control f12 hc-37"
              placeholder="Tên MC/Email/SĐT"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              placeholder="Thời gian"
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label style="min-width: 13.5em" class="text-center pt-1">
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2
              placeholder="Vùng kinh doanh"
              v-model="search.regionId"
              :options="dataRegion"
              @change="queryProvince($event)"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.cityCode"
              :options="dataProvince"
              placeholder="Tỉnh/Thành phố"
            ></Select2>
          </div>
          <div class="form-group form-group-action">
            <button
              class="btn btn-primary hc-37 mr-2 pt-2"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
              @click="submitSearch()"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              class="btn btn-outline-light hc-37 mr-2 pt-2"
              type="button"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
              @click="removeSearch()"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
            <button
              v-if="dataPermission && dataPermission.includes('CNPS_CSTM_LANDING_UNDEFINED_XLS')"
              @click="exportExcel()"
              type="button"
              class="btn btn-info hc-37 mr-2 pt-2 file-input"
              data-toggle="tooltip"
              data-placement="top"
              title="Xuất Excel"
            >
              <i class="bx bx-download"></i>
              <span class="ml-1">&nbsp;</span>Xuất Excel
            </button>
          </div>
        </div>
      </div>

      <div
        class="card-body"
        v-if="dataPermission && dataPermission.includes('CNPS_CSTM_LANDING_UNDEFINED_VIEW')"
      >
        <div class="tab-content" id="nav-tabContent">
          <div class="table-responsive">
            <table class="table table-hover table-bordered" id="tableScroll">
              <thead class="thead-light">
                <tr>
                  <th scope="col" width="50">STT</th>
                  <th scope="col" width="">Thời gian tạo</th>
                  <th scope="col" width="">Merchant</th>
                  <th scope="col" width="">Địa chỉ</th>
                  <th scope="col" width="">Vùng kinh doanh</th>
                  <th scope="col" width="">Ghi chú</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="loading">
                  <td colspan="11" align="center">
                    <i class="bx bx-loader-circle bx-spin bx-rotate-90 f30"></i>
                  </td>
                </tr>
                <tr v-else class="table-row" v-for="(item, index) in dataMCLanding" :key="index">
                  <td>{{ search.limit * (search.page - 1) + index + 1 }}</td>
                  <td>
                    {{ item.createAt | formatDate('HH:mm DD/MM/YYYY') }}
                  </td>
                  <td>
                    <div>{{ item.regName }}</div>
                    <div>{{ item.regEmail }}</div>
                    <div>
                      <a href="#">{{ item.regMobile }}</a>
                    </div>
                  </td>
                  <td>{{ item.district }}, {{ item.city }}</td>
                  <td>
                    {{ item.regionId | transfromRegion(dataRegion) }}
                  </td>
                  <td>
                    {{ item.regNote }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="pagination-bottom">
      <b-pagination
        v-model="search.page"
        :total-rows="pagination.total"
        :per-page="search.limit"
        class="fl-right mr-2"
      ></b-pagination>
    </div>
  </div>
</template>
<script>
  import { MerchantService } from '@/services/merchant.service'
  import { StaffService } from '@/services/staff.service'
  import DateRangePicker from 'vue2-daterange-picker'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import moment from 'moment'
  import { mapGetters } from 'vuex'
  import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
  export default {
    components: {
      DateRangePicker,
    },
    mixins: [prepareQueryParamsMixin],
    data() {
      return {
        search: {
          page: 1,
          limit: 20,
        },
        pagination: {
          total: 0,
        },
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataMCLanding: [],
        localeData: {
          direction: 'ltr',
          format: 'dd/mm/yyyy',
          separator: ' - ',
          applyLabel: 'Áp dụng',
          cancelLabel: 'Hủy bỏ',
          weekLabel: 'W',
          daysOfWeek: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
          monthNames: [
            'Tháng 1',
            'Tháng 2',
            'Tháng 3',
            'Tháng 4',
            'Tháng 5',
            'Tháng 6',
            'Tháng 7',
            'Tháng 8',
            'Tháng 9',
            'Tháng 10',
            'Tháng 11',
            'Tháng 12',
          ],
          firstDay: 0,
        },
        dateRange: {
          startDate: null,
          endDate: null,
        },
        dataStaff: [],
        dataRegion: [],
        dataProvince: [],
        loading: true,
      }
    },
    filters: {
      transfromRegion(regionId, dataRegion) {
        const data = dataRegion.filter(e => e.id === regionId)
        if (data.length === 0) {
          return ''
        }
        return data[0].text
      },
    },
    created() {
      this.fetchData()
      this.getRegions()
    },
    watch: {
      'search.limit': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          limit: this.search.limit,
          page: this.search.page,
        })
      },
    },
    methods: {
      async fetchData() {
        try {
          if (this.search.regionId === '0') delete this.search.regionId
          // this.search.agentId = this.dataUser.userId
          this.loading = true
          const response = await MerchantService.listMCLanding(this.search)
          if (response.success) {
            this.dataMCLanding = response.data
            this.pagination.total = response.meta.pagination.total
              ? response.meta.pagination.total
              : 0
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      // xuất file excel
      async exportExcel() {
        try {
          this.loading = true
          await MerchantService.exportMCLanding(this.search)
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      // define ngày trên lịch
      transformDate() {
        this.search.startDate = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.endDate = moment(this.dateRange.endDate).endOf('day').add(7, 'hours').valueOf()
      },
      // Lọc
      async submitSearch() {
        this.pagination.page = 1
        this.fetchData()
      },
      // Bỏ lọc
      async removeSearch() {
        this.search = {
          limit: 20,
          page: 1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        await this.fetchData()
      },
      // lấy vùng
      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.success) {
          this.dataRegion = data.data.map(e => {
            return { id: e.id, text: e.name }
          })
        }
      },
      // lấy tỉnh, tp
      async queryProvince(e) {
        if (this.search.regionId === '0') {
          this.dataProvince = []
          delete this.search.cityCode
        }
        try {
          const data = await StaffService.getProvinceRegion({ regionId: [e] })
          if (data.data.length > 0) {
            this.dataProvince = data.data.map(e => {
              return { id: e.code, text: e.name }
            })
          }
        } catch (error) {}
      },
    },
  }
</script>
<style scoped></style>
